import { Injectable } from '@angular/core';
import { ArcService } from './arc.service'

@Injectable()
export class SearchLogService {
  private logsMap = new Map<string, Object>()
  private resolveInitialized = new Set<string>()

  constructor(private arcs: ArcService) { }

  resolve(slid: string) {
    let data = this.logsMap.get(slid)
    if (!data) {
      if (!this.resolveInitialized.has(slid)) {
        this.resolveInitialized.add(slid)
        let obs = this.arcs.run({
          fun: 'resolveSearchLog',
          id: slid
        })
        obs.subscribe((resp) => {
          console.log(135, resp)
          this.logsMap.set(slid, resp['data'] || 'NOT RESOLVED')
        })
      }
      return null
    }

    return data
  }

}



// WEBPACK FOOTER //
// ./src/app/search-log.service.ts